
<template>

        <v-data-table
    :headers="kioskHeaders"
    :items="kiosks"
    :single-expand="singleExpand"
    :expanded.sync="expanded"
    item-key="name"
    show-expand
    class=" ma-6 elevation-1"
    
  >


    <template v-slot:top>
      <v-toolbar flat >

        
        <v-toolbar-title class="mt-2">Welcomed Kiosks

              <v-switch
              class="ml-3 mt-1"
      v-model="switch1"
      :label="`Populate results`"

    ></v-switch>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-switch
          v-model="singleExpand"
          label="Single expand"
  
        ></v-switch>
      </v-toolbar>
    </template>
    <template v-slot:expanded-item="{ headers, item }">
      <td :colspan="headers.length">
        <pre>{{ JSON.stringify(item.jobsFlag.jobs, null, 2) }}</pre>
      </td>
    </template>
  </v-data-table>

</template>

<script>

import axios from 'axios';

  export default {
    name: 'KioskTable',

    data: () => ({
      expanded: [],
      singleExpand: false,
      switch1: true,
      kioskHeaders: [
        {
          text: 'kiosk',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        { text: 'mac', value: 'macAddress' },
        { text: 'VPN', value: 'vpnAddress' },
        { text: '', value: 'data-table-expand' },
      ],
      kiosks: []
    }),
    mounted () {
      this.refreshDatas(true)
    },

    watch:{
      switch1(newValue){
        this.refreshDatas(newValue)
      }
    },

  methods: {
    refreshDatas: function(isPopulated){
      let that = this;

      var config = {
        method: 'get',
        url: process.env.VUE_APP_API_EXT_URL+'/kiosks?isPopulated='+isPopulated,
        headers: { Authorization: 'Bearer '+localStorage.getItem('jwt')}
      };
      axios(config)
        .then(function (response) {
          console.log(response.data);
          that._data.kiosks = response.data;
        })
      .catch(function (error) {
        console.log(error);
      });
    } 
  }
  }
</script>
